<template>
  <div>
    <div class="top">
      <div class="top-banner">
        <div class="top-banner-bg">
          <div class="content-wrap">
            <div class="img">
              <!-- <img src="../../assets/img/company/top-logo.svg" alt="" /> -->
            </div>
            <div class="text-wrap">
              <p class="main-text" v-html="$t('company.mainText')"></p>
              <p v-show="$i18n.locale != 'en'" class="sub-text">
                Virtual Asset Investment Platform
              </p>
              <p class="years">2017 - {{ thisYear }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="over-container">
        <div class="second-banner">
          <div class="text-wrap">
            <div class="title" v-html="calcYear + $t('company.about')"></div>
            <div class="sub" v-html="$t('company.aboutSub')"></div>
          </div>
        </div>
        <!-- content -->
        <div class="content-wrap">
          <!-- 카드 6개 -->
          <div class="summary-card" flex>
            <div
              v-for="(item, index) in company.items"
              :key="index"
              class="card"
              flex
              fic
              fjc
            >
              <div>
                <div class="img">
                  <img :src="item.thumnail" alt="" />
                </div>
                <div class="text-wrap">
                  <p class="sub" v-html="$t(item.sub)"></p>
                  <p class="main">{{ item.main }}</p>
                  <p class="third" v-html="$t(item.third)"></p>
                </div>
              </div>
            </div>
          </div>
          <!-- 중간 텍스트 -->
          <div class="middle-text">
            <div v-if="$i18n.locale === 'ko'" class="title anim-text-flow">
              <img src="../../assets/img/company/color-title-ko.svg" alt="" />
            </div>
            <div v-else-if="$i18n.locale === 'en'" class="title anim-text-flow">
              <img src="../../assets/img/company/color-title-en.png" alt="" />
            </div>
            <div v-else class="title anim-text-flow">
              <img src="../../assets/img/company/color-title-ch.png" alt="" />
            </div>
            <p
              class="sub anim-text-flow"
              v-html="$t('company.content.summary.subText')"
            ></p>
          </div>
          <!-- 미션, 비전 -->
          <div class="mission-vision">
            <div class="item-wrap" flex>
              <div class="mission-wrap">
                <div class="mission">
                  <div class="text-wrap">
                    <p class="main">Mission</p>
                    <p v-show="$i18n.locale !== 'en'" class="sub">
                      {{ $t("company.content.summary.missionKo") }}
                    </p>
                  </div>
                </div>
                <p
                  class="description"
                  v-html="$t('company.content.summary.missionDescription')"
                ></p>
              </div>
              <div class="vision-wrap">
                <div class="vision">
                  <div class="text-wrap">
                    <p class="main">Vision</p>
                    <p v-show="$i18n.locale !== 'en'" class="sub">
                      {{ $t("company.content.summary.visionKo") }}
                    </p>
                  </div>
                </div>
                <p
                  class="description"
                  v-html="$t('company.content.summary.visionDescription[0]')"
                ></p>
                <p
                  class="description sub"
                  v-html="$t('company.content.summary.visionDescription[1]')"
                ></p>
              </div>
            </div>
            <div class="value">
              <div class="title">
                {{ $t("company.content.coreValue") }}
              </div>
              <div class="card-wrap">
                <div
                  v-for="(list, index) in company.lists"
                  :key="index"
                  class="value-card"
                >
                  <div class="image">
                    <img :src="list.thumnail" alt="" />
                  </div>
                  <div class="text-wrap">
                    <p class="mini-title">{{ list.miniTitle }}</p>
                    <p class="sub" v-html="list.sub"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 강점 - glide slide -->
          <div class="strong-wrap">
            <div class="strong">
              <div class="text-wrap">
                <p class="title">{{ $t("company.strongth") }}</p>
                <p class="sub">{{ $t("company.strongthSub") }}</p>
              </div>
            </div>
            <div class="swipe-wrap glide">
              <div class="glide__track" data-glide-el="track">
                <ul class="swipe-wrap-card glide__slides">
                  <li
                    v-for="(card, index) in company.swipeCards"
                    :key="index"
                    class="card-content glide__slide"
                  >
                    <img :src="card.thumnail" alt="" />
                    <div class="title">{{ card.title }}</div>
                    <ul>
                      <li
                        v-for="(list, index) in card.swipeLists"
                        :key="index"
                        class="strong-list"
                        v-html="list.sub"
                      ></li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div class="glide__arrows" data-glide-el="controls">
                <button
                  class="glide__arrow glide__arrow--left"
                  data-glide-dir="<"
                ></button>
                <button
                  class="glide__arrow glide__arrow--right"
                  data-glide-dir=">"
                ></button>
              </div>
            </div>
          </div>
          <div class="bottom-contents">
            <!-- 5대전략 -->
            <div class="strategy-content">
              <div class="text-wrap">
                <p class="main">{{ $t("company.starategyTitle") }}</p>
                <p class="sub">{{ $t("company.starategySub") }}</p>
              </div>
              <div class="five-circle">
                <div
                  v-for="(item, index) in company.strategyCircle"
                  :key="index"
                  class="red-bg"
                >
                  <div class="white-bg">
                    <div class="five-icon">
                      <img :src="item.thumnail" alt="" />
                    </div>
                    <div class="five-text">
                      <p v-html="item.text"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 연혁  -->
            <div class="history-content">
              <div class="history-text-wrap">
                <p class="main">{{ $t("company.historyTitle") }}</p>
                <p v-show="$i18n.locale !== 'en'" class="sub">
                  {{ $t("company.historySub") }}
                </p>
              </div>
              <div class="history-card">
                <div
                  v-for="(item, index) in company.history"
                  :key="index"
                  class="gray-bg"
                >
                  <div class="history-title">{{ item.year }}</div>
                  <ul class="history-list">
                    <li
                      v-for="(list, index) in item.historyLists"
                      :key="index"
                      v-html="list.text"
                    ></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="partners-wrap">
            <div class="partrners-title">
              <p class="main">{{ $t("company.partners") }}</p>
              <p class="sub" v-html="$t('company.partnersSub')"></p>
            </div>
            <div class="partners-card" flex>
              <div
                v-for="(item, index) in company.parters"
                :key="index"
                class="card"
              >
                <a :href="item.partnersURL" target="_blank">
                  <img
                    :width="index === 8 ? '100%' : 'inherit'"
                    :src="item.thumnail"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Glide from "@glidejs/glide";

export default {
  components: {
    moment,
  },
  mounted() {
    new Glide(".glide", {
      type: "slider",
      startAt: 0,
      perView: 1.15,
    }).mount();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    company() {
      return {
        items: [
          {
            thumnail: require("@/assets/img/company/card1.svg"),
            sub: this.$t("company.items[0].sub"),
            main: this.$t("company.items[0].main"),
            third: this.$t("company.items[0].third"),
          },
          {
            thumnail: require("@/assets/img/company/card2.svg"),
            sub: this.$t("company.items[1].sub"),
            main: this.$t("company.items[1].main"),
          },
          {
            thumnail: require("@/assets/img/company/card3.svg"),
            sub: this.$t("company.items[2].sub"),
            main: this.$t("company.items[2].main"),
          },
          {
            thumnail: require("@/assets/img/company/card4.svg"),
            sub: this.$t("company.items[3].sub"),
            main: this.$t("company.items[3].main"),
            third: this.$t("company.items[3].third"),
          },
          {
            thumnail: require("@/assets/img/company/card5.svg"),
            sub: this.$t("company.items[4].sub"),
            main: this.$t("company.items[4].main"),
            third: this.$t("company.items[4].third"),
          },
          {
            thumnail: require("@/assets/img/company/card6.svg"),
            sub: this.$t("company.items[5].sub"),
            main: this.$t("company.items[5].main"),
            third: this.$t("company.items[5].third"),
          },
        ],
        lists: [
          {
            thumnail: require("@/assets/img/company/sec-card1.png"),
            miniTitle: this.$t("company.lists[0].miniTitle"),
            sub: this.$t("company.lists[0].sub"),
          },
          {
            thumnail: require("@/assets/img/company/sec-card2.png"),
            miniTitle: this.$t("company.lists[1].miniTitle"),
            sub: this.$t("company.lists[1].sub"),
          },
          {
            thumnail: require("@/assets/img/company/sec-card3.png"),
            miniTitle: this.$t("company.lists[2].miniTitle"),
            sub: this.$t("company.lists[2].sub"),
          },
        ],
        swipeCards: [
          {
            thumnail: require("@/assets/img/company/swipe-img1.png"),
            title: this.$t("company.swipeCards[0].title"),
            swipeLists: [
              { sub: this.$t("company.swipeCards[0].swipeLists[0].sub") },
              { sub: this.$t("company.swipeCards[0].swipeLists[1].sub") },
              { sub: this.$t("company.swipeCards[0].swipeLists[2].sub") },
            ],
          },
          {
            thumnail: require("@/assets/img/company/swipe-img2.png"),
            title: this.$t("company.swipeCards[1].title"),
            swipeLists: [
              { sub: this.$t("company.swipeCards[1].swipeLists[0].sub") },
              { sub: this.$t("company.swipeCards[1].swipeLists[1].sub") },
            ],
          },
          {
            thumnail: require("@/assets/img/company/swipe-img4.png"),
            title: this.$t("company.swipeCards[2].title"),
            swipeLists: [
              { sub: this.$t("company.swipeCards[2].swipeLists[0].sub") },
            ],
          },
          {
            thumnail: require("@/assets/img/company/swipe-img3.png"),
            title: this.$t("company.swipeCards[3].title"),
            swipeLists: [
              { sub: this.$t("company.swipeCards[3].swipeLists[0].sub") },
              { sub: this.$t("company.swipeCards[3].swipeLists[1].sub") },
              { sub: this.$t("company.swipeCards[3].swipeLists[2].sub") },
            ],
          },
        ],
        strategyCircle: [
          {
            thumnail: require("@/assets/img/company/sec-circle1.png"),
            text: this.$t("company.strategyCircle[0].text"),
          },
          {
            thumnail: require("@/assets/img/company/sec-circle3.png"),
            text: this.$t("company.strategyCircle[1].text"),
          },
          {
            thumnail: require("@/assets/img/company/sec-circle2.png"),
            text: this.$t("company.strategyCircle[2].text"),
          },
          {
            thumnail: require("@/assets/img/company/sec-circle4.png"),
            text: this.$t("company.strategyCircle[3].text"),
          },
          {
            thumnail: require("@/assets/img/company/sec-circle5.png"),
            text: this.$t("company.strategyCircle[4].text"),
          },
        ],
        history: [
          {
            year: "2021",
            historyLists: [
              {
                text: this.$t("company.history[4].historyLists[0]"),
              },
              {
                text: this.$t("company.history[4].historyLists[1]"),
              },
              {
                text: this.$t("company.history[4].historyLists[2]"),
              },
              {
                text: this.$t("company.history[4].historyLists[3]"),
              },
              {
                text: this.$t("company.history[4].historyLists[4]"),
              },
            ],
          },
          {
            year: "2020",
            historyLists: [
              {
                text: this.$t("company.history[3].historyLists[0]"),
              },
              {
                text: this.$t("company.history[3].historyLists[1]"),
              },
              {
                text: this.$t("company.history[3].historyLists[2]"),
              },
              {
                text: this.$t("company.history[3].historyLists[3]"),
              },
            ],
          },
          {
            year: "2019",
            historyLists: [
              {
                text: this.$t("company.history[2].historyLists[0]"),
              },
            ],
          },
          {
            year: "2018",
            historyLists: [
              {
                text: this.$t("company.history[1].historyLists[0]"),
              },
              {
                text: this.$t("company.history[1].historyLists[1]"),
              },
              {
                text: this.$t("company.history[1].historyLists[2]"),
              },
            ],
          },
          {
            year: "2017",
            historyLists: [
              {
                text: this.$t("company.history[0].historyLists[0]"),
              },
            ],
          },
        ],
        parters: [
          {
            // ramda
            partnersURL: "https://www.luniverse.io/",
            thumnail: require("/static/img/company/logo_ramda.png"),
          },
          {
            // certik
            partnersURL: "https://www.certik.com/",
            thumnail: require("/static/img/company/logo_certik.svg"),
          },
          {
            // hexlant
            partnersURL: "https://hexlant.com/",
            thumnail: require("/static/img/company/logo_hexlant.png"),
          },
          {
            // haechi
            partnersURL: "https://haechi.io/ko",
            thumnail: require("/static/img/company/logo_heachi.png"),
          },
          {
            // token
            partnersURL: "https://tokeninsight.com/",
            thumnail: require("/static/img/company/logo_tokeninsight.png"),
          },
          {
            // coinness
            partnersURL: "https://coinness.live/",
            thumnail: require("/static/img/company/logo_coinness.png"),
          },
          {
            // xangle
            partnersURL: "https://xangle.io/",
            thumnail: require("/static/img/company/logo_xangle.png"),
          },
          {
            // 동아송강
            partnersURL: "http://skcpa.cafe24.com/",
            thumnail: require("/static/img/company/logo_donga.png"),
          },
          {
            // 평안
            partnersURL: "http://pyeonganlawfirm.com/",
            thumnail: require("/static/img/company/logo_pyeongan.png"),
          },
        ],
      };
    },
    thisYear() {
      return moment().format("YYYY");
    },
    calcYear() {
      return Number(moment().format("YYYY")) - 2016;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "node_modules/@glidejs/glide/src/assets/sass/glide.core";
.top {
  p {
    margin-bottom: 0;
  }
  .top-banner {
    &-bg {
      width: 100%;
      padding: 42px 12px 54px;
      background-image: url("../../assets/img/company/top-bg.png");
      background-repeat: no-repeat;
      background-size: cover;
      .content-wrap {
        .img {
          width: 23px;
          height: 29px;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .text-wrap {
          text-align: center;
          color: #fff;
          p.main-text {
            margin-top: 8px;
            font-size: 18px;
            font-weight: 300;
          }
          p.sub-text {
            margin-top: 4px;
            font-size: 12px;
            font-weight: 300;
          }
          p.years {
            margin-top: 4px;
            font-size: 32px;
            font-weight: bold;
            opacity: 0.2;
          }
        }
      }
    }
  }
  .over-container {
    padding: 34px 12px 50px;
    text-align: center;
    .second-banner {
      .text-wrap {
        .title {
          font-size: 18px;
          font-weight: normal;
          color: #222;
        }
        .sub {
          margin-top: 4px;
          font-size: 10px;
          font-weight: 300;
          color: #444;
        }
      }
    }
    .content-wrap {
      .summary-card {
        padding: 28px 0 0;
        .card {
          width: calc((100% - 12px) / 2);
          height: 210px;
          margin: 0 12px 12px 0;
          padding: 10px;
          border-radius: 8px;
          box-shadow: 0px 16px 42px 0 rgba(0, 0, 0, 0.1);
          background-color: #ffffff;
          &:nth-child(2n) {
            margin-right: 0;
          }
          .img {
            height: 80px;
            img {
              height: 100%;
            }
          }
          .text-wrap {
            .sub {
              margin-top: 6px;
              font-size: 10px;
              font-weight: 300;
              color: #444;
            }
            .main {
              width: 140px;
              height: 22px;
              margin: 8px auto 0;
              font-size: 12px;
              line-height: 22px;
              font-weight: normal;
              color: #ff505f;
              border-radius: 80px;
              background-color: rgba(255, 80, 95, 0.1);
            }
            .third {
              margin-top: 4px;
              font-size: 10px;
              font-weight: 300;
              color: #ff505f;
            }
          }
        }
      }
      .middle-text {
        padding-top: 68px;
        .anim-text-flow {
          img {
            width: 100%;
          }
          &.sub {
            margin-top: 14.6px;
            font-size: 12px;
            font-weight: 300;
            color: #444;
          }
        }
      }
      .mission-vision {
        .item-wrap {
          padding-top: 48px;
          .mission-wrap {
            width: calc((100% - 8px) / 2);
            .mission {
              position: relative;
              width: 164px;
              height: 164px;
              margin: 0 auto;
              background-image: url("../../assets/img/company/circle-bg1.png");
              background-repeat: no-repeat;
              background-size: cover;
              .text-wrap {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: #fff;
              }
            }
          }
          .vision-wrap {
            padding: relative;
            width: calc((100% - 8px) / 2);
            margin-left: 8px;
            .vision {
              position: relative;
              width: 164px;
              height: 164px;
              margin: 0 auto;
              background-image: url("../../assets/img/company/circle-bg2.svg");
              background-repeat: no-repeat;
              background-size: cover;
              .text-wrap {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: #fff;
              }
            }
          }
          .description {
            margin-top: 14px;
            font-size: 12px;
            font-weight: normal;
            color: #222;
            &.sub {
              margin-top: 4px;
            }
          }
        }
        .value {
          padding-top: 80px;
          .title {
            font-size: 18px;
            font-weight: normal;
            color: #222;
          }
          .card-wrap {
            .value-card {
              width: 100%;
              margin-top: 24px;
              padding: 40px 28px 52px;
              object-fit: contain;
              box-shadow: 0 16px 42px 0 rgba(0, 0, 0, 0.05);
              background-color: #ffffff;
              .text-wrap {
                padding-top: 16px;
                .mini-title {
                  position: relative;
                  padding-bottom: 8px;
                  font-size: 14px;
                  font-weight: normal;
                  color: #222;
                  &:after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 16px;
                    height: 2px;
                    background-color: rgba(0, 0, 0, 0.2);
                  }
                }
                .sub {
                  margin-top: 8px;
                  font-size: 12px;
                  font-weight: 300;
                  color: #444;
                }
              }
            }
          }
        }
      }
      .strong-wrap {
        padding-top: 80px;
        .strong {
          .text-wrap {
            margin-bottom: 24px;
            .title {
              font-size: 18px;
              font-weight: normal;
              color: #222;
            }
            .sub {
              margin-top: 4px;
              font-size: 12px;
              font-weight: 300;
              color: #444;
            }
          }
        }
        .swipe-wrap {
          position: relative;
          width: 100%;
          .swiper-container {
            overflow: inherit;
          }
          .swipe-wrap-card {
            height: 267px;
            position: relative;
            list-style: none;
            .card-content {
              position: relative;
              // width: 300px;
              height: 276px;
              padding: 69px 0 0 10px;
              text-align: left;
              img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
              }
              .title {
                position: relative;
                padding-bottom: 20px;
                font-size: 20px;
                font-weight: normal;
                color: #fff;
                &:after {
                  content: "";
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 16px;
                  height: 2px;
                  background-color: #ff505f;
                }
              }
              ul {
                position: absolute;
                top: 130px;
                left: 24px;
                list-style: none;
                li.strong-list {
                  position: relative;
                  width: 320px;
                  margin-bottom: 10px;
                  font-size: 12px;
                  font-weight: 300;
                  line-height: 1.43;
                  color: #fff;
                  &:before {
                    content: "";
                    position: absolute;
                    top: 9px;
                    left: -12px;
                    width: 4px;
                    height: 4px;
                    border-radius: 50px;
                    background-color: #fff;
                  }
                }
              }
            }
          }
          .glide__arrows {
            position: absolute;
            bottom: -54px;
            left: 50%;
            transform: translateX(-50%);
            width: 120px;
            height: 44px;
            button {
              border-radius: 0;
            }
            .glide__arrow--left,
            .glide__arrow--right {
              position: relative;
              width: 60px;
              height: 44px;
              background-color: #222;
              cursor: pointer;
            }
            .glide__arrow--left {
              position: absolute;
              top: 0;
              left: 0;
              &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-image: url("../../assets/img/company/swipe-arrow-left.svg");
                width: 12px;
                height: 26px;
              }
            }
            .glide__arrow--right {
              position: absolute;
              top: 0;
              right: 0;
              &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-image: url("../../assets/img/company/swipe-arrow-right.svg");
                width: 12px;
                height: 26px;
              }
            }
          }
        }
      }
      .bottom-contents {
        margin-top: 134px;
        .strategy-content {
          .text-wrap {
            .main {
              font-size: 18px;
              font-weight: normal;
              color: #000;
            }
          }
          .five-circle {
            position: relative;
            width: 336px;
            height: 336px;
            margin: 86px auto 62px;
            border: 4px dashed rgba(255, 80, 95, 0.2);
            border-radius: 200px;
            .red-bg {
              position: absolute;
              width: 160px;
              height: 160px;
              box-shadow: 0 12px 36px 0 rgba(255, 80, 95, 0.3);
              background-image: linear-gradient(
                220deg,
                rgba(245, 78, 93, 0.3) 86%,
                #ff96c8 0
              );
              border-radius: 100px;
              &:first-child {
                top: -62px;
                left: 0;
              }
              &:nth-child(5n-3) {
                top: -62px;
                right: 0;
              }
              &:nth-child(5n-2) {
                top: 88px;
                left: 88px;
              }
              &:nth-child(5n-1) {
                bottom: -62px;
                left: 0;
                letter-spacing: -0.1;
              }
              &:last-child {
                bottom: -62px;
                right: 0;
              }
              .white-bg {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 124px;
                height: 124px;
                border-radius: 100px;
                background-color: #fff;
                .five-icon {
                  margin-top: 5px;
                }
                .five-text {
                  font-size: 12px;
                  font-weight: normal;
                  color: #222;
                }
              }
            }
          }
        }
        .history-content {
          padding-top: 80px;
          .history-text-wrap {
            .main {
              font-size: 18px;
              font-weight: normal;
              color: #000;
            }
          }
          .history-card {
            margin-top: 24px;
            padding: 24px 0 30px 18px;
            object-fit: contain;
            background-image: linear-gradient(to bottom, #f5f7fc, #ffffff);
            .gray-bg {
              margin-top: 48px;
              .history-title {
                position: relative;
                font-family: "Roboto";
                text-align: left;
                font-size: 20px;
                font-weight: normal;
                line-height: 1.3;
                color: #222;

                &:after {
                  content: "";
                  position: absolute;
                  bottom: -17px;
                  left: 0;
                  width: 15px;
                  height: 2px;
                  margin: 8px 0 12px;
                  background-color: #b4becd;
                }
              }
              ul.history-list {
                list-style: none;
                li {
                  position: relative;
                  padding: 12px 0 0 8px;
                  text-align: left;
                  font-size: 13px;
                  font-weight: normal;
                  color: #444;
                  &:before {
                    content: "";
                    position: absolute;
                    top: 20px;
                    left: 0;
                    width: 4px;
                    height: 4px;
                    border-radius: 100px;
                    background-color: #000;
                  }
                }
              }
              &:first-child {
                margin-top: 0;
              }
            }
          }
        }
      }
      .partners-wrap {
        .partrners-title {
          margin-top: 50px;
          .main {
            font-size: 18px;
            font-weight: normal;
            color: #222;
          }
          .sub {
            margin-top: 4px;
            font-size: 12px;
            font-weight: 300;
            color: #444;
          }
        }
        .partners-card {
          margin-top: 24px;
          .card {
            position: relative;
            width: 50%;
            height: 67px;
            padding: 0 15px;
            img {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: fit-content;
            }
          }
        }
      }
    }
  }
}
</style>
